import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/content";

// Abstract "fusion / connectivity" node-network mark.
export const LogoMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="ftg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2563EB" />
        <stop offset="0.55" stopColor="#7C3AED" />
        <stop offset="1" stopColor="#06B6D4" />
      </linearGradient>
    </defs>
    {/* connecting lines */}
    <path d="M24 8 L38 16 M24 8 L10 16 M10 16 L10 32 M38 16 L38 32 M10 32 L24 40 M38 32 L24 40 M24 8 L24 40 M10 16 L38 32 M38 16 L10 32"
      stroke="url(#ftg)" strokeWidth="1.6" strokeLinecap="round" opacity="0.55" />
    {/* nodes */}
    <circle cx="24" cy="8" r="4" fill="url(#ftg)" />
    <circle cx="38" cy="16" r="3.2" fill="url(#ftg)" />
    <circle cx="10" cy="16" r="3.2" fill="url(#ftg)" />
    <circle cx="10" cy="32" r="3.2" fill="url(#ftg)" />
    <circle cx="38" cy="32" r="3.2" fill="url(#ftg)" />
    <circle cx="24" cy="40" r="4" fill="url(#ftg)" />
    <circle cx="24" cy="24" r="3" fill="url(#ftg)" />
  </svg>
);

export const Logo = ({ className = "", showText = true, size = 34 }) => (
  <Link
    to="/"
    data-testid="brand-logo"
    className={`inline-flex items-center gap-2.5 group ${className}`}
    aria-label={`${COMPANY.name} home`}
  >
    <LogoMark size={size} className="transition-transform duration-500 group-hover:rotate-90" />
    {showText && (
      <span className="font-display text-lg font-semibold tracking-tight leading-none">
        Fusion<span className="brand-gradient-text">Tech</span>
      </span>
    )}
  </Link>
);

export default Logo;
